/// <amd-module name="Wit/SprintsHub/SprintsView/Utils/DaysOffValidationUtils" />
import { equals } from "VSS/Core/Util/String";
import * as Resources from "Wit/SprintsHub/SprintsView/Resources";
import { shiftToUTC } from "Wit/Common/DateUtils";

export interface DateRangeTableItem {
    start?: Date;
    end?: Date;
    errorMessage?: string;
    totalRow?: boolean;
}

export function getDaysOffErrorMessage(start?: Date, end?: Date, iterationStartDate?: Date, iterationEndDate?: Date): string | undefined {
    // Check for null/empty, and whether start < end
    if (!start) {
        return Resources.StartDateRequiredError;
    } else if (!end) {
        return Resources.EndDateRequiredError;
    } else if (start > end) {
        return Resources.EndLaterThanStartError;
    }

    // Validate date range is within the iteration
    if (iterationStartDate && start < shiftToUTC(iterationStartDate)) {
        return Resources.StartWithinIterationError;
    } else if (iterationEndDate && end > shiftToUTC(iterationEndDate)) {
        return Resources.EndWithinIterationError;
    }
}

export function runDateRangeOverlapValidation(daysOff: DateRangeTableItem[]) {
    const sortedDaysOff = daysOff.slice().sort(dialogDaysOffStartComparer);
    let endDate: Date;

    // For each days off, if the start date is within another date range, that one is invalid
    sortedDaysOff.forEach(current => {
        if (!current.start || !current.end) {
            return;
        }

        // Update the unsorted validation fields
        if (current.start && current.start <= endDate) {
            if (!current.errorMessage) {
                current.errorMessage = Resources.DateRangeOverlapError;
            }
        } else if (equals(current.errorMessage ?? "", Resources.DateRangeOverlapError)) {
            // Only reset overlap error messages
            current.errorMessage = undefined;
        }

        // Set the current to have the maximum end date to mark multiple overlaps
        if (!endDate || current.end > endDate) {
            endDate = current.end;
        }
        return current;
    });
}

function dialogDaysOffStartComparer(a: DateRangeTableItem, b: DateRangeTableItem): number {
    if (!a.start && !b.start) {
        return 0;
    }
    if (!a.start) {
        return -1;
    }
    if (!b.start) {
        return 1;
    }

    return roundToDays(a.start) - roundToDays(b.start);
}

function roundToDays(date: Date) {
    return (new Date(date)).setUTCHours(0,0,0,0);
}
